import { useContext } from 'react';
import { UnifiedProfilesValuesContext } from './context';

export const useUnifiedProfilesValues = () => {
  const context = useContext(UnifiedProfilesValuesContext);

  if (!context) {
    throw new Error('useUnifiedProfilesValues must be used within a UnifiedProfilesProvider');
  }

  return context;
};
